document.addEventListener("DOMContentLoaded", function () {
  const czPath = "/pages/fry-trial";
  const roUrl = "https://huuust.ro/pages/test-de-prajit";

  const infoBoxLinks = document.querySelectorAll(".info-box a");

  if (!infoBoxLinks.length) {
    console.warn("Huuust BG link replace: no .info-box links found.");
  }

  infoBoxLinks.forEach(function (link) {
    const rawHref = link.getAttribute("href") || "";
    const fullHref = link.href || "";

    const isFryTrialLink =
      rawHref.includes(czPath) ||
      fullHref.includes(czPath);

    if (isFryTrialLink) {
      link.setAttribute("href", roUrl);
      console.log("Huuust RO link replace: changed link to BG URL", link);
    }
  });

    document.querySelectorAll(".footer-link").forEach(function (link) {
    const rawHref = link.getAttribute("href") || "";

    console.log("Footer link found:", rawHref);

    if (
      rawHref === "https://www.huuust.cz/account" ||
      rawHref === "https://huuust.cz/account"
    ) {
      link.setAttribute("href", "/account");
      console.log("Huuust account link changed to relative /account", link);
    }
  });
});